import { userRequest } from '../requestMethods';
import config from '../config';
const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getEvent = async () => {
  return userRequest.get(`${DOMAIN}/api/event`);
};

export const getEventRapportDay = async (params) => {
  return userRequest.get(`${DOMAIN}/api/event/rapport_day`);
};

export const getEventRow = async (params) => {
  return userRequest.get(`${DOMAIN}/api/event/raw_report`, { params });
};

export const postEvent = async (data) => {
  return userRequest.post(`${DOMAIN}/api/event`, data);
};

export const getConnectivity = async(params) => {
  return userRequest.get(`${DOMAIN}/api/event/connectivity`, { params });
}

export const getGeofences = async(params) => {
  return userRequest.get(`${DOMAIN}/api/point_in_geofences`, { params });
}

export const getConnectivityDetail = async(params) => {
  return userRequest.get(`${DOMAIN}/api/event/connectivityDetail`, { params });
}

export const getConnectivityMonth = async (month) => {
  return userRequest.get(`${DOMAIN}/api/event/connectivity/month`, { params: { month } });
};

export const getDetailAlerteType = async (idVehicule) => {
  return userRequest.get(`${DOMAIN}/api/event/connectivity/detailAlertType`, { params: { idVehicule } });
};